import React from "react";
import Main from "../components/layout/Main";

import Profile from "../pages/consultant/profile/Profile";

import Consultant from "../pages/admin/Consultant";

import ConsultantCreate from "../pages/admin/ConsultantCreate";
import ConsultantProfiledetails from "../pages/admin/consultant/ConsultantProfileDetails";
import Usercreate from "../pages/UserCreate";
import { Route, Routes } from "react-router-dom";
import Referalcode from "../pages/Referalcode";
import ConsultantCoinRedeem from "../pages/Redeem/RedeemCoin";
import ConsultantProfile from "../pages/admin/consultant/ConsultantProfile";

// import UserProfile from "../pages/admin/UserProfile";
import UserProfileDetails from "../pages/admin/user/UserProfileDetails";
import Reports from "../pages/admin/report/Reports";
import { ConsultantApplications } from "../pages/admin/application/ConsultantApplications";
import { ApplicationDetail } from "../pages/admin/application/ApplicationDetail";
import UserProfile from "../pages/admin/user/UserProfile";

const admin = () => {
  return (
    <Main>
      <Routes>
        <Route exact path="/" element={<ConsultantProfile />} />
        <Route exact path="/profile/:id" element={<Profile />} />
        <Route exact path="/usercreate" element={<Usercreate />} />

        <Route exact path="/consultant" element={<Consultant />} />
        <Route exact path="/referalcode" element={<Referalcode />} />
        <Route
          exact
          path="/consultantcreate/:id"
          element={<ConsultantCreate />}
        />
        <Route
          exact
          path="/consultant-profile"
          element={<ConsultantProfile />}
        />
        <Route
          exact
          path="/consultant-details/:id"
          element={<ConsultantProfiledetails />}
        />
        <Route exact path="/redeem-coin" element={<ConsultantCoinRedeem />} />
        <Route
          exact
          path="/consultant-applications"
          element={<ConsultantApplications />}
        />
        <Route
          exact
          path="/consultant-applications/:id"
          element={<ApplicationDetail />}
        />
        <Route exact path="/users" element={<UserProfile />} />
        <Route
          exact
          path="/user-details/:id"
          element={<UserProfileDetails />}
        />
        <Route exact path="/reports" element={<Reports />} />
      </Routes>
    </Main>
  );
};

export default admin;
